import React, { FC } from 'react';
import { observer } from 'mobx-react';
import QuestionCard from './question-card';
import QuestionActionForm from './../question-action-form/question-action-form';
import { TUpdateQuestion } from '../../../../store/question-store/question-store';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { TReviewModeAdditionalAction } from '../questions-review-mode-container/questions-review-mode-container';
import QuestionEntity, { EditableState } from '../../../../store/question-store/question-entetiy';

interface IQuestionCardContainerProps {
  updateQuestion: TUpdateQuestion;
  question: QuestionEntity;
  isDisabled: boolean;
  handleProps?: DraggableProvidedDragHandleProps;
  reviewModeAdditionalAction?: TReviewModeAdditionalAction;
  isSpecialActionButton?: boolean;
  isReviewMode?: boolean;
  editableQuestionId: string | null;
  setEditableQuestionState: (id: string | null, state: EditableState) => void;
}

const QuestionCardContainer: FC<IQuestionCardContainerProps> = observer(({
  updateQuestion,
  question,
  isDisabled,
  reviewModeAdditionalAction,
  isSpecialActionButton,
  isReviewMode,
  editableQuestionId,
  setEditableQuestionState,

}): JSX.Element => {
  return question.getEditableState() === EditableState.OPENED ?
    <QuestionActionForm
      question={question}
      editableQuestionId={editableQuestionId}
      setEditableQuestionState={setEditableQuestionState}
    />
    :
    <QuestionCard
      reviewModeAdditionalAction={reviewModeAdditionalAction}
      isSpecialActionButton={isSpecialActionButton}
      isReviewMode={isReviewMode}
      isDisabled={isDisabled}
      key={question.messageId}
      updateQuestion={updateQuestion}
      question={question}
      setEditableQuestionState={setEditableQuestionState}
    />;
});

export default QuestionCardContainer;
